// src/components/operationCenter/widgets/token/risk/TwRollingVolatilityWidget.tsx
import React from "react";
import type { WidgetProps, TokenWidgetConfig } from "@/types/dashboard";
import { TokenWidgetWrapper } from "../TokenWidgetWrapper";
import { TokenWidgetConfigPanel } from "../TokenWidgetConfig";
import RollingVolatilityCard from "@/components/tokenPage/risk/RollingVolatilityCard";

const TwRollingVolatilityWidget: React.FC<WidgetProps<TokenWidgetConfig>> = ({
  widget,
  onConfigChange,
}) => {
  const config = widget.config as TokenWidgetConfig;
  return (
    <TokenWidgetConfigPanel config={config} onConfigChange={onConfigChange} widgetType={widget.type}>
      <TokenWidgetWrapper ticker={config.ticker} providers={["price"]}>
        <RollingVolatilityCard />
      </TokenWidgetWrapper>
    </TokenWidgetConfigPanel>
  );
};

export default TwRollingVolatilityWidget;
